module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAANtJREFUKBWtTzsKwkAQnZkYFC08gUWsYmGteA2jCBbmAnojwcLGzzk8gAopU4idn0rRZsedhFXJBywcmN3H+8zuAPyjvGC71L3KmkVJsh/su8zQ0+0JTupoCD8MS7fnvaOUmgFwLebxQER+pVjezBznIVwU8ILdnAE8YC7GxsSJ+NTGxbrRHJkv1XPNkpVBDK7AKIBoD/WEqxBZJRqSPRAtCqxcN2TCSZY54gjG4nkHYkCnvACCdTaa2UGvr6qGTN1f2icAdERE/QpOybJaULDaghHwwgoOqSG/Ei8BqT6S2fYRiQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhutui.png
// module id = 609
// module chunks = 2